module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The editor would like to thank the following individuals who assisted in his efforts to prepare Reed’s manuscript for printing:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lt. Col. Henry Persons, USA (Retired) for sharing his copy of the Reed manuscript.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. Emory M. Thomas, Regents Professor of History Emeritus at the University of Georgia Department of History, for his early review and comments on the Reed manuscript, and for his encouragement to publish it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nona Thornton of the Oglethorpe County Historical Society in Lexington, Georgia, for her kind assistance in locating and searching historical records on John C. Reed and his family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Linda Helmley, the current president of the Oglethorpe County Historical Society, for her time and effort in research and discussions about John Calvin Reed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Matthew Reeder, Archives Assistant, The Mudd Manuscript Library, Princeton University, for sharing documents from Reed’s file and other information on Reed’s college years. Also for his efforts to identify Reed’s Princeton classmates who were mentioned in the manuscript.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Richard M. Allen for sharing his excellent annotated and updated Roster of the 8th Georgia Volunteer Infantry, which was extremely helpful in identifying many of the soldiers mentioned in the manuscript.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cartographer Hal Jespersen of CWMaps.com for his excellent work preparing maps for this book, and particularly for his efforts transposing the details of Reed’s crude, hand drawn map of the First Manassas Battlefield onto the scaled map included in "), _c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Horn for his detailed review and very insightful comments and suggestions on the manuscript, and for his permission to use maps from his books that were drawn by Hampton Newsome.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Theodore P. Savas of Savas Beatie for his interest in publishing the manuscript and also his guidance and encouragement in getting the print-ready manuscript prepared.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0xii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("John C. Reed (ca. 1900). "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Atlanta Constitution")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-061e3a74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Acknowledgments.vue
// module id = 72
// module chunks = 0